module.exports = __webpack_public_path__ + "static/media/no.b137a28a.svg";